export const AGENDA_PAGE = "/";
export const CLIENT_PAGE = "/clients";
export const NOTIF_PAGE = "/notifications";
export const RELATION_PAGE = "/relations";

export const LOGIN_PAGE = "/connexion";
